import InternalBlogPage, { InternalBlogPageProps } from './InternalBlogPage';

export type { InternalBlogPageProps };
export default InternalBlogPage;
